<template>
  <div class="pa-2 rounded elevation-1 bg-white">
    <div class="text-h6">Ma commande</div>

    <div class="d-flex justify-content-between align-center mb-2">
      <v-badge :content="cart.nb_articles">
        <v-icon icon="mdi-cart" color="primary" size="x-large"></v-icon>
      </v-badge>
      <div class="d-flex flex-column align-end">
        <div>Sous total: {{ cart.prix }}€</div>
        <div>Frais de gestion: {{ cart.taxe }}€</div>
        <div class="text-h6">
          A payer: <span class="font-weight-bold">{{ cart.prix_total }}€</span>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column gap">
      <div class="bg-grey_1 bordered pa-2 rounded" v-for="(option, index_option) in cart.options" :key="index_option">
        <div class="text-body font-weight-bold">{{ option.beneficiaire }}</div>
        <div class="d-flex justify-start align-center small-gap p-2 my-2 cart_course_item">
          <div>
            <v-badge :content="option.quantite_souhaite" inline></v-badge>
          </div>
          <div>
            <div class="text-body-1">{{ option.nom }}</div>
          </div>
          <div class="justify-self-end text-body font-weight-bold">
            <span v-if="option.prix">{{ option.prix }}€</span><span v-else>Gratuit</span>
          </div>
        </div>
      </div>
      <div class="bg-grey_1 bordered pa-2 rounded" v-for="(activite, index_activite) in cart.activites"
        :key="index_activite">
        <div class="text-body font-weight-bold">{{ activite.beneficiaire }}</div>
        <div class="d-flex justify-start align-center small-gap p-2 my-2 cart_course_item">
          <div>
            <v-badge :content="activite.quantite_souhaite" inline></v-badge>
          </div>
          <div>
            <div class="text-body-1">{{ activite.nom }}</div>
          </div>
          <div class="justify-self-end text-body font-weight-bold">
            <span v-if="activite.prix">{{ activite.prix }}€</span><span v-else>Gratuit</span>
          </div>
        </div>
      </div>
      <div class="bg-grey_1 bordered pa-2 rounded" v-for="(article, index_article) in cart.articles"
        :key="index_article">
        <div class="text-body font-weight-bold">{{ article.beneficiaire }}</div>
        <div class="d-flex justify-start align-center small-gap p-2 my-2 cart_course_item">
          <div>
            <v-badge :content="article.quantite_souhaite" inline></v-badge>
          </div>
          <div>
            <div class="text-body-1">{{ article.nom }}</div>
          </div>
          <div class="justify-self-end text-body font-weight-bold">
            <span v-if="article.prix">{{ article.prix }}€</span><span v-else>Gratuit</span>
          </div>

        </div>
        <div class="pl-4" v-for="size in get_selected_sizes(article)" :key="size.id">
          {{ size.quantite_souhaite }}x <b>taille {{ size.nom }}</b>
        </div>
      </div>
      <div class="bg-grey_1 bordered pa-2 rounded" v-for="(alerte_sms_item, index_alerte_sms) in cart.alertes_sms"
        :key="index_alerte_sms">
        <div class="text-body font-weight-bold">{{ alerte_sms_item.beneficiaire }}</div>
        <div class="d-flex justify-start align-center small-gap p-2 my-2 cart_course_item">
          <div>
            <v-icon icon="mdi-message-processing-outline" color="primary"></v-icon>
          </div>
          <div>
            <div class="text-body-1">Alerte de suivi par SMS</div>
          </div>
          <div class="justify-self-end text-body font-weight-bold">
            <span v-if="alerte_sms_item.prix">{{ alerte_sms_item.prix }}€</span><span v-else>Gratuit</span>
          </div>
        </div>
      </div>
      <div class="bg-grey_1 bordered pa-2 rounded" v-for="(plan_entrainement_item, index_plan) in cart.plans_entrainement"
        :key="'plan-' + index_plan">
        <div class="text-body font-weight-bold">{{ plan_entrainement_item.beneficiaire }}</div>
        <div class="d-flex justify-start align-center small-gap p-2 my-2 cart_course_item">
          <div>
            <v-icon icon="mdi-run" color="primary"></v-icon>
          </div>
          <div>
            <div class="text-body-1">{{ plan_entrainement_item.titre }}</div>
          </div>
          <div class="justify-self-end text-body font-weight-bold">
            <span v-if="plan_entrainement_item.prix">{{ plan_entrainement_item.prix }}€</span><span v-else>Gratuit</span>
          </div>
        </div>
      </div>
      <div class="bg-grey_1 bordered pa-2 rounded" v-for="(envoi_postal_item, index_envoi) in cart.envois_postal"
        :key="'envoi-' + index_envoi">
        <div class="text-body font-weight-bold">{{ envoi_postal_item.beneficiaire }}</div>
        <div class="d-flex justify-start align-center small-gap p-2 my-2 cart_course_item">
          <div>
            <v-icon icon="mdi-truck-delivery-outline" color="primary"></v-icon>
          </div>
          <div>
            <div class="text-body-1">Envoi postal du dossard</div>
          </div>
          <div class="justify-self-end text-body font-weight-bold">
            <span v-if="envoi_postal_item.prix">{{ envoi_postal_item.prix }}€</span><span v-else>Gratuit</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: ["cart"],
  methods: {
    get_selected_sizes(article) {

      let sizes = article.sizes.filter((size) => size.quantite_souhaite > 0);

      return sizes;
    },
  }
};
</script>

<style lang="scss" scoped></style>